import { createElement } from "react";
import React from "react";
import * as react from "react";
import { unwrap, defaultArg } from "../../fable_modules/fable-library-js.4.24.0/Option.js";
import { reactApi } from "../../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../../Context.js";
import { Components_Chip_51BC9844, ComponentsModule_Chip_Level } from "../Chip.js";
import { createObj } from "../../fable_modules/fable-library-js.4.24.0/Util.js";
import AccessTime from "@mui/icons-material/AccessTime";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import Cached from "@mui/icons-material/Cached";
import CheckCircle from "@mui/icons-material/CheckCircle";
import MoreHoriz from "@mui/icons-material/MoreHoriz";
import { Tickets_TicketStatus__ToString_12C6553D } from "../../Shared/Shared.js";

export function Tickets_StatusChip_Z17F2D702(tickets_StatusChip_Z17F2D702InputProps) {
    const onEnable = tickets_StatusChip_Z17F2D702InputProps.onEnable;
    const enabled = tickets_StatusChip_Z17F2D702InputProps.enabled;
    const readOnly = tickets_StatusChip_Z17F2D702InputProps.readOnly;
    const status = tickets_StatusChip_Z17F2D702InputProps.status;
    const readOnly_1 = defaultArg(readOnly, false);
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(true);
    const inner = patternInput[0];
    const handleOnClick = readOnly_1 ? undefined : (() => {
        patternInput[1](!inner);
        if (onEnable != null) {
            onEnable();
        }
    });
    const color = (status.tag === 2) ? (new ComponentsModule_Chip_Level(0, [])) : ((status.tag === 3) ? (new ComponentsModule_Chip_Level(3, [])) : ((status.tag === 1) ? (new ComponentsModule_Chip_Level(0, [])) : ((status.tag === 4) ? (new ComponentsModule_Chip_Level(1, [])) : (new ComponentsModule_Chip_Level(5, [])))));
    const icon = (status.tag === 2) ? ((props_3) => {
        const props_5 = createObj(props_3);
        return react.createElement(AccessTime, props_5);
    }) : ((status.tag === 3) ? ((props_6) => {
        const props_8 = createObj(props_6);
        return react.createElement(InfoOutlined, props_8);
    }) : ((status.tag === 1) ? ((props_9) => {
        const props_11 = createObj(props_9);
        return react.createElement(Cached, props_11);
    }) : ((status.tag === 4) ? ((props_12) => {
        const props_14 = createObj(props_12);
        return react.createElement(CheckCircle, props_14);
    }) : ((props) => {
        const props_2 = createObj(props);
        return react.createElement(MoreHoriz, props_2);
    }))));
    return createElement(Components_Chip_51BC9844, {
        key: "",
        $key: "",
        primary: Tickets_TicketStatus__ToString_12C6553D(status, ctx.Language),
        enabled: defaultArg(enabled, inner),
        startIcon: icon,
        onClick: unwrap(handleOnClick),
        colorLevel: color,
    });
}

